export default "__VITE_ASSET__CadmktBZ__"